import { TextBlock } from '@terminal/components/text-block/TextBlock';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import { useTranslation } from 'react-i18next';

type InsightsReactionProps = {
  entityName: string;
  episodeCount: number;
  isFixedIncome: boolean;
};

export const InsightsReaction = ({
  entityName,
  episodeCount,
  isFixedIncome,
}: InsightsReactionProps) => {
  const { t } = useTranslation(['scenarioCommander', 'analyze']);

  /* i18next-extract-mark-context-next-line ["price", "yield"]*/
  const chartTitlePrefix = t('analyze:experiment.chart.chartTitle', {
    entityName,
    context: isFixedIncome ? 'yield' : 'price',
  });

  return (
    <TextBlock
      data-testid="insights-reaction"
      text={
        <span>
          {chartTitlePrefix}
          <TooltipContainer
            label={t('analyze:experiment.chart.tooltip')}
            showUnderline
          >
            <span>
              {t('analyze:experiment:chart.episodeCount', {
                count: episodeCount,
              })}
            </span>
          </TooltipContainer>
        </span>
      }
    />
  );
};
